import { call, put, takeEvery, all } from 'redux-saga/effects';
import { Routine } from 'redux-saga-routines';
import { completeLeverIntegrationRoutine } from './routines';
import { completeLeverIntegration } from '../../services/workspaceService';

function* completeLeverIntegrationReq({ payload }: Routine<any>) {
  try {
    yield call(completeLeverIntegration, payload);
    window.opener?.location.reload();
    window.close();
  } catch (error) {
    yield put(completeLeverIntegrationRoutine.failure(error.message));
  }
}

function* watchCompleteLeverIntegration() {
  yield takeEvery(completeLeverIntegrationRoutine.TRIGGER, completeLeverIntegrationReq);
}

export default function* integrationCallbackSaga() {
  yield all([watchCompleteLeverIntegration()]);
}
